import { createContext, useContext, type ReactNode } from "react";

interface AppContextValue {
  sidebarCollapsed: boolean;
  isHovered: boolean;
}

const AppContext = createContext<AppContextValue>({
  sidebarCollapsed: false,
  isHovered: false,
});

export function AppProvider({
  children,
  value,
}: {
  children: ReactNode;
  value?: Partial<AppContextValue>;
}) {
  return (
    <AppContext.Provider
      value={{
        sidebarCollapsed: value?.sidebarCollapsed ?? false,
        isHovered: value?.isHovered ?? false,
      }}
    >
      {children}
    </AppContext.Provider>
  );
}

export function useAppContext() {
  return useContext(AppContext);
}
